import { Token } from "../models/Gateway";

export class TokenUtil {

    static fillToken(token: Token) {
        const now = new Date();
        token.startDate = new Date();
        const tokenTime = token.expires_in.toDate().getTime() - token.issued_at.toDate().getTime();
        const endDate = new Date();
        endDate.setTime(now.getTime() + tokenTime);
        token.endDate = endDate;
        return token;
    }
}